import React, { createContext } from "react";
const DEFAULT_VARIANTS = { inherit: "currentColor" };
export const Context = createContext({
  variants: DEFAULT_VARIANTS
});
export const ArcadeIconProvider = ({ variants = {}, children }) => {
  return /* @__PURE__ */ React.createElement(Context.Provider, { value: { variants: { ...DEFAULT_VARIANTS, ...variants } } }, children);
};
